import { formatCurrency, formatDecimalUnit, formatDecimalWithGroupedUnit } from "@/common/utils/formatters";
import { CompanyGovernmentAllocationDistribution, ControlledByType } from "@/features/privateCompanies/types/companyGovernmentAllocation.type";

export const updateGovernmentAllocationDistributionDefaultValues = (
  distribution: CompanyGovernmentAllocationDistribution,
  controlledBy: ControlledByType = 'currency'
) => {
  const isQuantity = controlledBy === 'quantity';

  if (isQuantity) {
    return {
      total_quantity: formatDecimalUnit(Number(distribution.total_quantity)),
      product_categories_distributions: distribution.product_categories_distributions.map((productCategoryDistribution) => {
        return {
          id: productCategoryDistribution.id,
          product_category: productCategoryDistribution.product_category,
          total_quantity: formatDecimalWithGroupedUnit(
            Number(productCategoryDistribution.total_quantity),
            productCategoryDistribution.products_distributions,
            (p) => p.product.unit_for_quantity,
          ),
          products_distributions: productCategoryDistribution.products_distributions.map((productDistribution) => {
            return {
              id: productDistribution.id,
              product: productDistribution.product,
              total_quantity: formatDecimalUnit(Number(productDistribution.total_quantity), productDistribution.product.unit_for_quantity),
            };
          }),
        };
      }),
    };
  }

  return {
    total_value: formatCurrency(Number(distribution.total_value) || 0),
    product_categories_distributions: distribution.product_categories_distributions.map((productCategoryDistribution) => {
      return {
        id: productCategoryDistribution.id,
        product_category: productCategoryDistribution.product_category,
        total_value: formatCurrency(Number(productCategoryDistribution.total_value) || 0),
        products_distributions: productCategoryDistribution.products_distributions.map((productDistribution) => {
          return {
            id: productDistribution.id,
            product: productDistribution.product,
            total_value: formatCurrency(Number(productDistribution.total_value) || 0),
          };
        }),
      };
    }),
  };
};
